import { render, staticRenderFns } from "./ClientAlertCheckbox.vue?vue&type=template&id=663e25c8&"
import script from "./ClientAlertCheckbox.vue?vue&type=script&lang=js&"
export * from "./ClientAlertCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports